import axios from 'axios';
import { getUrl } from './service-utils';

export const API_URL = getUrl();

export const loginWithGoogle = async (accessToken: string) => {
  try {
    // Send authorization code to the back end for exchange
    const res = await axios.post(API_URL + 'users/loginWithGoogleWeb', {
      token: accessToken
    });
    console.log('Server response:', res.data);
    // Store the JWT token in local storage or cookies
    if (res.data.token) {
      localStorage.setItem('user', JSON.stringify(res.data));
    }

    // Handle successful login
    return true;
  } catch (error) {
    console.error('Error logging in with Google:', error);
  }
};
